import type { Endpoints } from 'consts/api';
import type { FlowType } from 'consts/flows';
import type { UserState } from 'store/state';
import type { AppConfig } from 'types';
import { createProcessFlowTypeNumber } from './converters';

export function queryString(params: Record<string, string | number | boolean>) {
	const nonEmpty = Object.keys(params).reduce((map: Record<string, string | number | boolean>, key) => {
		if (params[key]) map[key] = params[key];
		return map;
	}, {});
	const searchParams = new URLSearchParams(nonEmpty as Record<string, string>).toString();
	return `?${searchParams}`;
}

export function productsURL(API: Endpoints, processId: string, isExternal: boolean) {
	const qs = `externalCreditCheck=${isExternal ? 'true' : 'false'}`;
	return `${API.products}/${processId}/GetProducts?${qs}`;
}

export function getRelationsURL(config: AppConfig, user: UserState, flowType: FlowType) {
	const { API, IS_EMPLOYEE_WEB } = config;
	const { companyKennitala, isManualSignCompany, kennitala } = user;
	const flowTypeNumber = createProcessFlowTypeNumber(flowType);
	const ssn =
		IS_EMPLOYEE_WEB && isManualSignCompany && companyKennitala ? `&companyssn=${companyKennitala}` : '';
	const qs = `?flowType=${flowTypeNumber}&ssn=${kennitala}${ssn}`;
	return API.getIndividualAndCompaniesInfo + qs;
}
